import classes from './checkbox.module.css'

const Checkbox = {
  defaultProps: {
    size: 'sm',
  },
  classNames: {
    root: classes.root,
    input: classes.input,
    label: classes.label,
  },
}

export default Checkbox
